import { useEffect, useState } from 'react'
import { CuentaCorporate } from '../types/types'
import { HttpCorporate } from '../api/httpCorporate'
import { QueryStatus } from 'src/types'

export const useCuentas = (idOperacion: number) => {
    const [cuentas, setCuentas] = useState<CuentaCorporate[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpCorporate.getCuentas(idOperacion)
            .then(value => {
                setCuentas(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { cuentas, refetch, status }
}
